
const WordCloud = require('./cloud')
const description = require('./word_cloud_description.html')

const NAME = '단어 구름'

module.exports = {
    name: NAME,
    add: (analysis) => new WordCloud(analysis),
    description: description,
}
